import(/* webpackMode: "eager", webpackExports: ["BottomBar"] */ "/vercel/path0/components/BottomBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainNav"] */ "/vercel/path0/components/main-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/WebVitalsLogger.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Noto_Sans_KR\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"NotoSansKR\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/globals.css");
